import { Fragment, useCallback, useState } from "react";
import { Box, Typography, Link as MUILink, useTheme } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { navMenu } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";

import DropDownMenu from "../DropDownMenu";
import HeaderButtons from "../HeaderButtons";
import Logo from "@/components/UI-Kit/Logo";

const NavBar = () => {
  const { pathname } = useLocation();
  const theme = useTheme();
  const isDesktop = useResponsive("up", "lg");

  const [activeMenu, setActiveMenu] = useState<string | null>(null); // Active drop-down menu
  const [anchorElDropDown, setAnchorElDropDown] = useState<null | HTMLElement>(
    null
  );

  const openDropDown = useCallback(
    (event: React.MouseEvent<HTMLElement>, path: string) => {
      setAnchorElDropDown(event.currentTarget);
      setActiveMenu(path);
    },
    []
  );

  const closeDropDown = useCallback(() => {
    setAnchorElDropDown(null);

    setTimeout(() => {
      setActiveMenu(null);
    }, 300);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      {/* Logo */}
      <Box display="flex" pb={isDesktop ? 3 : 0} sx={{ flex: "0 0 auto" }}>
        <Logo type="dark" onClick={closeDropDown} />
      </Box>

      {/* Links */}
      <Box 
        display="flex" 
        justifyContent="center"
        alignItems="center"
        sx={{ flex: "1 1 auto" }}
      >
        {navMenu.map(({ path, title, submenu }) => {
          return (
            <Fragment key={path}>
              {submenu ? (
                <DropDownMenu
                  openDropDown={openDropDown}
                  closeDropDown={closeDropDown}
                  anchorElDropDown={anchorElDropDown}
                  title={title}
                  path={path}
                  activeMenu={activeMenu}
                />
              ) : (
                <MUILink
                  component={Link}
                  to={path}
                  sx={{
                    padding: "40px 16px",
                    color:
                      pathname === path
                        ? theme.palette.primary.main
                        : theme.palette.grey[800],
                  }}
                >
                  <Typography
                    color="inherit"
                    variant="body1"
                    textTransform="capitalize"
                    display="block"
                    fontSize={16}
                    fontWeight={500}
                  >
                    {title}
                  </Typography>
                </MUILink>
              )}
            </Fragment>
          );
        })}
      </Box>

      {/* Buttons */}
      <Box sx={{ flex: "0 0 auto" }}>
        <HeaderButtons />
      </Box>
    </Box>
  );
};

export default NavBar;
